import { render, staticRenderFns } from "./UpdateCustomerRepName.vue?vue&type=template&id=222f2dfa&scoped=true"
import script from "./UpdateCustomerRepName.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerRepName.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerRepName.vue?vue&type=style&index=0&id=222f2dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f2dfa",
  null
  
)

export default component.exports